import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Iconify } from 'src/components/iconify';
import { useTranslate } from 'src/locales';

import { labelClasses } from './classes';
import { Label } from './label';

type PausePeriod = { startAt: string; endAt: string | null } | boolean | null | undefined;

interface PauseBadgeProps {
  activeRemindersPause: PausePeriod;
  activeDcPause: PausePeriod;
}

const PauseLabel = styled(Label)(({ theme }) => ({
  width: 'fit-content',
  minHeight: 28,
  height: 'auto',
  padding: theme.spacing(0.5, 1.25),
  gap: theme.spacing(0.75),
  fontWeight: theme.typography.fontWeightSemiBold,
  fontSize: theme.typography.pxToRem(13),
  color: theme.vars.palette.warning.dark,
  backgroundColor: theme.vars.palette.warning.lighter,
  [`& .${labelClasses.icon}`]: {
    width: 18,
    height: 18,
    color: 'inherit',
  },
}));

export function PauseBadge({ activeRemindersPause, activeDcPause }: PauseBadgeProps) {
  const { t } = useTranslate();

  const hasReminders = Boolean(activeRemindersPause);
  const hasDc = Boolean(activeDcPause);

  if (!hasReminders && !hasDc) return null;

  if (hasReminders && hasDc) {
    return (
      <PauseLabel
        variant="soft"
        color="warning"
        startIcon={<Iconify icon="lucide:triangle-alert" width={18} />}
      >
        {t('pages.content.pauseScopes.both')}
      </PauseLabel>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      {hasReminders && (
        <PauseLabel
          variant="soft"
          color="warning"
          startIcon={<Iconify icon="lucide:triangle-alert" width={18} />}
        >
          {t('pages.content.pauseScopes.reminders')}
        </PauseLabel>
      )}
      {hasDc && (
        <PauseLabel
          variant="soft"
          color="warning"
          startIcon={<Iconify icon="lucide:triangle-alert" width={18} />}
        >
          {t('pages.content.pauseScopes.dcTransfers')}
        </PauseLabel>
      )}
    </Stack>
  );
}
